"use strict";
/**
 * Component: AppMenuItem.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var mobx_react_1 = require("mobx-react");

var ExpandLess_1 = require("@material-ui/icons/ExpandLess");

var ExpandMore_1 = require("@material-ui/icons/ExpandMore"); // import DoubleArrow from '@material-ui/icons/DoubleArrow';


var Label_1 = require("@material-ui/icons/Label");

var LabelImportant_1 = require("@material-ui/icons/LabelImportant");

var AppMenuItem
/*: React.FC<IAppMenuItem>*/
= function AppMenuItem(props) {
  var _a = React.useState(false),
      open = _a[0],
      setOpen = _a[1];

  if (!props.appState || !props.visible) {
    return null;
  }

  var appState = props.appState;
  var label = props.label,
      pathTo = props.pathTo,
      depth = props.depth,
      folded = props.folded,
      disabled = props.disabled,
      icon = props.icon,
      onClick = props.onClick,
      children = props.children;
  var inset = true;

  var listItemIcon = function listItemIcon() {
    var vListItemIcon = React.createElement(React.Fragment, null);

    if (icon) {
      inset = false;
      vListItemIcon = React.createElement(core_1.ListItemIcon, null, React.createElement(props.icon, null));
    } else if (folded && !depth) {
      inset = false;
      vListItemIcon = React.createElement(core_1.ListItemIcon, null, React.createElement(Label_1.default, null));
    } else if (folded) {
      inset = false;
      vListItemIcon = React.createElement(core_1.ListItemIcon, null, React.createElement(LabelImportant_1.default, null));
    }

    return vListItemIcon;
  };

  var handleClick = function handleClick(e) {
    if (children) {
      setOpen(!open);
    } else {
      if (appState.menuState.drawerVariant === 'foldable') {
        appState.menuState.toogleFold();
      } else {
        appState.menuState.toogleDrawer();
      }

      if (pathTo) {
        appState.pantState.goPantalla(pathTo);
      }
    }

    if (onClick) {
      onClick();
    }
  };

  var width = props.folded ? {
    width: 56
  } : {};

  var style = __assign({
    minHeight: 48
  }, width);

  var childrens = function childrens() {
    if (props.children instanceof Array) {
      return props.children.map(function (element) {
        return React.cloneElement(element, {
          folded: folded
        });
      });
    } else if (!!props.children) {
      return React.cloneElement(props.children, {
        folded: folded
      });
    }

    return props.children;
  };

  return React.createElement(React.Fragment, null, React.createElement(core_1.ListItem, {
    button: true,
    onClick: handleClick,
    style: style,
    disabled: disabled
  }, listItemIcon(), !folded && React.createElement(core_1.ListItemText, {
    inset: inset,
    primary: label
  }), !folded && children && (open ? React.createElement(ExpandLess_1.default, null) : React.createElement(ExpandMore_1.default, null))), children && React.createElement(core_1.Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, React.createElement(core_1.List, {
    disablePadding: true
  }, childrens())));
};

AppMenuItem.defaultProps = {
  depth: 0,
  folded: true,
  disabled: false,
  visible: true
};
exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppMenuItem));